import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("sales") !== null && localStorage.getItem("sales") !== undefined && localStorage.getItem("sales") !== "") {

    data = JSON.parse(localStorage.getItem("sales"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getsales: (state, action) => {
            localStorage.setItem("sales", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { seedetails, home, getsales } = Insider.actions;
export default Insider.reducer;